export default "__VITE_ASSET__ac5b202c__"